(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nx-detail"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bind = (root) => {
      if (root.dataset.nxBound) return;
      root.dataset.nxBound = '1';
      const media = root.querySelector('[data-nx-detail-media]');
      const line = root.querySelector('[data-nx-detail-line]');
      const points = [...root.querySelectorAll('[data-nx-detail-point]')];
      const items = [...root.querySelectorAll('[data-nx-detail-item]')];
      if (!media || points.length === 0) return;

      const select = (i, focusZoom) => {
        points.forEach((p, j) => p.setAttribute('aria-pressed', String(j === i)));
        items.forEach((it, j) => (it.hidden = j !== i));
        const x = parseFloat(points[i].dataset.x);
        const y = parseFloat(points[i].dataset.y);
        // Ease the macro image toward the chosen point.
        media.style.setProperty('--ox', `${x}%`);
        media.style.setProperty('--oy', `${y}%`);
        media.style.setProperty('--s', focusZoom ? '1.18' : '1');
        // Thin line from the point toward the note below.
        root.classList.remove('is-drawn');
        line.setAttribute('x1', x);
        line.setAttribute('y1', y);
        line.setAttribute('x2', x < 50 ? Math.min(x + 18, 96) : Math.max(x - 18, 4));
        line.setAttribute('y2', 98);
        requestAnimationFrame(() => requestAnimationFrame(() => root.classList.add('is-drawn')));
      };

      points.forEach((p, i) => p.addEventListener('click', () => select(i, true)));
      select(0, false);
    };
    const start = () => document.querySelectorAll('[data-nx-detail]').forEach(bind);
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
    document.addEventListener('shopify:section:load', start);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nx-scene"] && !Shopify.designMode) return;
  try {
    
  (() => {
    // Slow push-in tied to scroll. Only `transform` changes, once per frame, and only while visible.
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const active = new Set();
    let ticking = false;

    const update = () => {
      ticking = false;
      const vh = window.innerHeight;
      active.forEach((el) => {
        const media = el.querySelector('[data-nx-scene-media]');
        if (!media) return;
        const r = el.getBoundingClientRect();
        // 0 when the scene enters from the bottom, 1 when it leaves at the top: a slow push-in.
        const p = Math.min(1, Math.max(0, (vh - r.top) / (vh + r.height)));
        const zoom = parseFloat(el.dataset.zoom || '10') / 100;
        media.style.setProperty('--nx-scene-scale', (1 + zoom * p).toFixed(4));
      });
    };
    const onScroll = () => {
      if (!ticking && active.size) {
        ticking = true;
        requestAnimationFrame(update);
      }
    };
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => (en.isIntersecting ? active.add(en.target) : active.delete(en.target)));
      onScroll();
    });
    const start = () => document.querySelectorAll('[data-nx-scene]').forEach((el) => io.observe(el));

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll, { passive: true });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
    else start();
    document.addEventListener('shopify:section:load', start);
  })();

  } catch(e) { console.error(e); }
})();
})();
